import { Eyebrow, Reveal } from "./Reveal";
import { differentials } from "../data/business";

export default function Differentials() {
    return (
        <section
            id="diferenciais"
            data-testid="differentials-section"
            className="grain relative bg-ink py-20 text-paper sm:py-28 lg:py-36"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Eyebrow light>Por que escolher?</Eyebrow>
                <Reveal delay={0.1}>
                    <h2 className="mt-5 max-w-3xl font-display text-3xl font-medium uppercase leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">
                        Não é apenas sobre o serviço.
                        <span className="italic text-accent"> É sobre como ele é entregue.</span>
                    </h2>
                </Reveal>

                <div className="mt-16 grid grid-cols-1 gap-px bg-line-dark sm:grid-cols-2 lg:grid-cols-4">
                    {differentials.map((d, i) => (
                        <Reveal key={d.title} delay={i * 0.1} className="h-full">
                            <div
                                data-testid={`differential-${i + 1}`}
                                className="group h-full bg-ink p-8 transition-colors duration-500 hover:bg-[#1a1b1f]"
                            >
                                <span className="font-mono text-[11px] tracking-[0.2em] text-accent">
                                    0{i + 1}
                                </span>
                                <h3 className="mt-10 font-display text-xl font-semibold tracking-wide">
                                    {d.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-paper/50">
                                    {d.desc}
                                </p>
                                <div className="mt-8 h-px w-10 bg-accent/60 transition-all duration-500 group-hover:w-full" />
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
